import React from 'react';
import { Route } from 'react-router-dom';

export const SVRoute = ({exact, path, component: Component}) => (
    <Route exact={exact} path={path} render={(props) => (
        <div>
            <Component {...props}/>
        </div>
    )}/>
);


// WEBPACK FOOTER //
// ./src/components/utils/SVRoute.js